import type { ReactNode } from 'react';
import { useStyles } from './styles.js';

type ResizableTableCellHeaderTextProps = {
    children: ReactNode;
};

export function ResizableTableCellHeaderText({ children }: ResizableTableCellHeaderTextProps) {
    const styles = useStyles();

    return <div className={styles.cellHeaderText}>{children}</div>;
}
